<template>
  <div class="block container-width">
    <div class="search-box pubc-boxs-s">
      <div class="block">
        <span class="label">快速查询</span>
        <div class="input ksmc">
          <input type="text" v-model="doctor" placeholder="科室名称/医师名称" />
        </div>
        <a @click="handleSearchDoctor" class="butn1">查询</a>
      </div>
    </div>
    <div class="title1">了解这些有可能对您的就诊有所帮助</div>
    <div class="container-width list">
      <div class="item">
        <router-link to="/jyzn">
          <i class="iconfont icon-jiuyizhinanhui"></i>
          <p>就医指南</p>
        </router-link>
      </div>
      <div class="item" @click="onlilnedialogVisible = true">
        <i class="iconfont icon-wangshangyuyue"></i>
        <p>手机预约</p>
      </div>
      <div class="item">
        <router-link to="/ylts/home">
          <i class="iconfont icon-keshi"></i>
          <p>科室介绍</p>
        </router-link>
      </div>
      <div class="item">
        <router-link to="/ylts/mingyi">
          <i class="iconfont icon-mingyi"></i>
          <p>盛京名医</p>
        </router-link>
      </div>

      <div class="item">
        <router-link to="/lxwm/dean">
          <i class="iconfont icon-xinfeng"></i>
          <p>联系我们</p>
        </router-link>
      </div>
    </div>
    <el-dialog
      :visible.sync="onlilnedialogVisible"
      width="75%"
      :append-to-body="true"
      title="手机预约"
    >
      <div v-html="onlilneUrl"></div>
    </el-dialog>
  </div>
</template>

<script>
import service from "../service/index";
export default {
  name: "FUNCTION",
  props: {},
  data() {
    return {
      doctor: "",
      onlilnedialogVisible: false,
      onlilneUrl: "", //获取网上预约 二维码
    };
  },
  methods: {
    // 搜索科室/医生
    handleSearchDoctor() {
      let searchContent = this.doctor;
      const { href } = this.$router.resolve({
        path: `/ylts/search`,
        query: {
          type: "doctor", //要传的参数
          searchContent: `${searchContent}`,
        },
      });
      window.open(href, "_blank");
    },
  },
  mounted() {
    service.getOnlineInfo({}, (res) => {
      this.onlilneUrl = res.description || "";
    });
  },
  watch: {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.block {
  .title1 {
    font-size: 24px;
    color: #333333;
    text-align: center;
  }
  .search-box {
    margin: 20px auto 30px;

    .block {
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      align-items: center;
      width: 80%;
      margin: 0 auto;
      .label {
        font-size: 18px;
        color: #333333;
        vertical-align: middle;
        font-weight: 500;
        padding: 0;
      }
      .input {
        width: 80%;
        flex: 1;
        input {
          width: 100%;
          height: 48px;
          line-height: 48px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          display: inline-block;
          vertical-align: middle;
          border: 1px solid #cccccc;
          border-radius: 5px;
          margin-left: 12px;
          padding: 8px 12px;
          font-size: 1rem;
          color: #333333;
          vertical-align: middle;
          font-weight: 500;
        }
        input::placeholder {
          text-align: left;
          color: #999;
          font-size: 1rem;
          color: #cccccc;
          vertical-align: middle;
          font-weight: 500;
          padding: 0;
        }
      }

      .butn1 {
        width: 128px;
        text-align: center;
        height: 48px;
        line-height: 48px;
        background: #00479d;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #fff;
        border-radius: 5px;
        margin-left: 40px;
        cursor: pointer;
        font-size: 1rem;
      }
    }
  }
  .list {
    display: -webkit-flex;
    display: flex;
    justify-content: space-evenly;
    margin-top: 30px;
    margin-bottom: 30px;

    .item {
      background: #fff;
      text-align: center;
      border: 1px solid #dedede;
      border-radius: 5px;
      -webkit-transition: all 0.4s ease;
      transition: all 0.4s ease;
      margin-right: 20px;
      flex: 1;
      padding: 10px 0;
      cursor: pointer;
      position: relative;
      i {
        font-size: 3rem;
        color: #333;
      }
      p {
        color: #333;
      }
      a {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        p {
          color: #333;
        }
      }
    }
    .item:last-child {
      margin-right: 0px;
    }
    .item:hover {
      background: #00479d;
      color: #fff;
      i {
        color: #fff;
      }

      a {
        p {
          color: #fff;
        }
      }
    }
  }
  @media only screen and (max-width: 420px) {
    .title1 {
      font-size: 1rem;
    }
    .search-box {
      margin: 10px 0 15px;
      .block {
        width: 100%;
        .label {
          font-size: 1rem;
        }
        .input {
          input {
            height: 36px;
            line-height: 36px;
            margin-left: 10px;
            margin-right: 10px;
          }
          input::placeholder {
            font-size: 1rem;
          }
        }

        .butn1 {
          width: 56px;
          text-align: center;
          height: 36px;
          line-height: 36px;
          font-size: 0.8rem;
          margin-left: 20px;
        }
      }
    }
    .list {
      margin-top: 15px;
      margin-bottom: 15px;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      .item {
        padding: 5px 0;
        margin-right: 10px;
        i {
          font-size: 1.2rem;
          color: #333;
        }
        p {
          font-size: 0.8rem;
        }
        a {
          font-size: 0.8rem;
          display: -webkit-flex;
          display: flex;
          -moz-flex-direction: column;
          -webkit-flex-direction: column;
          flex-direction: column;
          -webkit-justify-content: center;
          justify-content: center;

          p {
            font-size: 0.8rem;
          }
        }
      }
    }
  }
}
</style>
      
    
       